export default {"src":"/_next/static/media/interview-icon.c137ac60.svg","height":19,"width":18};